import {environmentVariable} from './Environment';

let Constants = {
  zIndex: {
    level1: 100,
    level2: 500,
    level3: 750,
    level4: 1000,
  },

  information: {
    supportEmail: 'support@waveride.co',
    supportEmailFull: 'Wave <support@waveride.co>',
    supportPhone: '1-833-WAVE2ME',
    supportPhoneE164: '+18339283263',
  },

  publicKeys: {
    appID: 'ad5a3ee9eda640cbaf0a042bef504099',
    firebaseMessagingPublicVAPIDKey:
      'BBy92WGKnV69OKfKeXjuu4fEKHW-ARMwRAgDD5x8js9SaReb3luqgO4GsLxZqlAtrH3dHj3BafcrsNXpHOp9SoE',
  },

  localStorageKeys: {
    firebaseTablePageSize: 'FIREBASE_TABLE_PAGE_SIZE',
  },

  //Pricing
  baseFare: 1.25,
  bookingFee: 2.3,
  minimumFare: 7.0,
  ratePerMile: 0.96,
  metersPerMile: 0.000621371,

  discount: {
    deadline: {
      specificTime: 0.15,
      specificTimeOffset: 4, //hours
      specificTimeRange: 14, //hours
    },
  },

  pricing: {
    multiplier: {
      scoopM: 1,
      scoopXl: 1.75,
      butler: 1.75,
      nanny: 1.75,
      taxi: 1.75,
      heli: 1.75,
      motorcycle: 1.75,
    },
  },

  //Our office location
  officeLocation: {lat: 35.229009, lng: -80.84577},

  theme: {
    primaryColorHexString: process.env.REACT_APP_COLOR_PRIMARY,
    primaryColorLightHexString: process.env.REACT_APP_COLOR_PRIMARY_LIGHT,
    primaryDarkColorHexString: process.env.REACT_APP_COLOR_PRIMARY_DARK,
    secondaryColorHexString: process.env.REACT_APP_COLOR_SECONDARY,
  },

  validation: {
    shortTextMax: 300,
    longTextMax: 1000,
  },

  driverAvailabilityRadiusKm: 50, // km
  maxDriverSearchRadiusKm: 250,
  minDriverSearchRadiusKm: 80.47,

  minimumBookingTimeH: 4,
  maximumBookingTimeH: 24 /* hours */ * 180 /* days */,

  minimumLuxH: 2,
  maximumLuxH: 12,

  stripePaymentIntentUrl: id =>
    `https://dashboard.stripe.com${process.env.REACT_APP_ENVIRONMENT !== 'production' ? '/test' : ''}/payments/${id}`,
};

export default Constants;

export const googleApiOptions = {
  apiKey: environmentVariable('GOOGLE_CLOUD_API_KEY'),
};
